export default "__VITE_ASSET__CMKp3Tio__"